var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from 'react';
var SvgComponent = function SvgComponent(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M9.58203 10L7.58984 8V7H9.41797L11 8.58V10H9.58203Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.58984 6L9.58203 4L11 4L10.9999 5.42097L9.41797 7L8.41797 8H7.58984L7.41016 8L4.41797 11H3L3.00012 9.57903L5.58203 7L3 4.42V3H4.41797L7.41016 6L7.58984 6Z",
    fill: "white"
  })));
};
export default __webpack_public_path__ + "static/media/tree-merge-2y-icon.6e1bd9eb.svg";
export { SvgComponent as ReactComponent };